import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from '../queries/queryKeys';

const addAttachments = async ({ meterId, files }) => {
  return await Promise.allSettled(
    files.map((file) => {
      const { fileType, ...fileData } = file;
      const type = fileType || 'file';

      const formData = new FormData();
      formData.append('file', fileData.originFileObj);

      return request.post(
        `/Meter/individual_meter/${meterId}/attachment?type=${type}`,
        formData,
        `При загрузке файла ${file.name} произошла ошибка`
      );
    })
  );
};

export const useAddFlatMeterAttachments = () => {
  const queryClient = useQueryClient();
  const addMutation = useMutation(addAttachments, {
    onSuccess: (_, { meterId }) => {
      queryClient.invalidateQueries(
        getQueryKeys.flatMetersAttachments(meterId)
      );
    },
  });

  return {
    addAttachments: addMutation.mutateAsync,
    loading: addMutation.isLoading,
  };
};
